import scroller from './scroller';

export default {
  scroller,
};
